export default __webpack_public_path__ + "e4d2ee8.png";